import * as RadixToggleGroup from '@radix-ui/react-toggle-group';

const base = `justify-center flex-grow relative flex items-center border border-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`;
const first = 'rounded-l-md';
const last = 'rounded-r-md';

export interface ToggleGroupProps {
  options: string[];
  selectedIndex?: number;
  onSelect: (index: number) => void;
  activeClass?: string;
  inactiveClass?: string;
  equalWidth?: boolean;
}

export function ToggleGroup({
  options,
  selectedIndex = 0,
  onSelect,
  activeClass = 'data-[state=on]:bg-white data-[state=on]:text-gray-700 border-w-3',
  inactiveClass = 'data-[state=off]:bg-gray-400 data-[state=off]:text-white',
  equalWidth = false,
}: ToggleGroupProps) {
  return (
    <RadixToggleGroup.Root
      type="single"
      value={selectedIndex.toString()}
      onValueChange={(value: string) => {
        onSelect(parseInt(value));
      }}
      className={getContainerClasses(equalWidth, options.length)}
    >
      {options.map((option, index, array) => (
        <RadixToggleGroup.Item
          value={index.toString()}
          className={`${activeClass} ${inactiveClass} ${base} ${
            index === 0 ? first : ''
          } ${index === array.length - 1 ? last : ''}`}
          key={option}
        >
          {option}
        </RadixToggleGroup.Item>
      ))}
    </RadixToggleGroup.Root>
  );
}

const getContainerClasses = (equalWidth: boolean, itemCount: number) => {
  const baseClasses = 'isolate rounded-md bg-gray-400 shadow-sm';

  if (!equalWidth) {
    return `${baseClasses} flex`;
  }

  const gridCols = classForColumnCount(itemCount);

  return gridCols ? `${baseClasses} grid ${gridCols}` : `${baseClasses} flex`;
};

const classForColumnCount = (count: number) => {
  switch (count) {
    case 2:
      return 'grid-cols-2';
    case 3:
      return 'grid-cols-3';
    case 4:
      return 'grid-cols-4';
    case 5:
      return 'grid-cols-5';
    case 6:
      return 'grid-cols-6';
    default:
      return null;
  }
};
